"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.RiskModelDescription = void 0;
const Field_type_1 = require("../../../types/Field.type");
exports.RiskModelDescription = {
    priority: 2,
    label: 'fields.payload.mor_group_answers.risk_model_description.label',
    fallbackLabel: 'How many risk classifications does your merchant risk scoring model contain and what are the time intervals for recollection and reverification (ODD) per risk classification?',
    mandatory: (payload, path) => isMandatory(payload, path),
    disabled: (payload, path) => false,
    applicable: (payload, path) => isApplicable(payload, path),
    applicableDependsOn: ['mor_group_answers.interval_is_risk_based', 'contract_onboarding_type'],
    type: Field_type_1.FieldType.String,
    trackFieldValueWithAnalytics: false,
};
function isMandatory(payload, path) {
    return payload.mor_group_answers?.interval_is_risk_based === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
function isApplicable(payload, path) {
    return payload.mor_group_answers?.interval_is_risk_based === true
        && (payload.contract_onboarding_type?.valueOf?.() === 'MOR_ONBOARDING_GROUP');
}
